import {
    getMessagesSuccess,
    getMessagesFail,
    getMessageByIdSuccess,
    getMessageByIdFail,
    getArchivedSuccess,
    getArchivedFail,
    getDeleteFail,
    getDeleteSuccess,
    updateMessageNoteSuccess,
    updateMessageNoteFail,
    resetData,
    searchMessagesSuccess,
    searchMessagesFail,
    moveToInboxSuccess,
    moveToInboxFail
}
    from '../constant';
import { toast } from "react-toastify";

export const initialState = {
    MessagesSuccess: {},
    MessageDetails: {},
    MessageDetailsFail: {},
};

let toastConfig = {
    position: toast.POSITION.TOP_RIGHT,
    autoClose: 2500,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case getMessagesSuccess:
            return {
                ...state,
                MessageDetails: null,
                MessagesSuccess: action.payload,
            };
        case getMessagesFail:
            return {
                ...state,
                MessagesFail: action.payload.message,
            };
            case searchMessagesSuccess:
                return {
                    ...state,
                    MessageDetails: null,
                    MessagesSuccess: action.payload,
                };
            case searchMessagesFail:
                return {
                    ...state,
                    MessagesSuccess:null,
                    MessagesFail: action.payload.message,
                };
        case getMessageByIdSuccess:
            return {
                ...state,
                MessageDetails: action.payload,
            };
        case getMessageByIdFail:
            return {
                ...state,
                MessageDetailsFail: action.payload.message,
            };
        case getArchivedSuccess:
            toast.success("Successfully Moved To Archived", toastConfig);
            let updatedData = state.MessagesSuccess?.results?.map(message =>
                (message.id === action.payload.id ? null : message)).filter(Boolean);
            return {
                ...state,
                archivedSuccess: action.payload,
                MessageDetails: null,
                MessagesSuccess: {
                    ...state.MessagesSuccess,
                    results: updatedData,
                },
            };
        case getArchivedFail:
            return {
                ...state,
                archivedFail: action.payload.message,
            };
        case moveToInboxSuccess:
            toast.success("Successfully Moved To Inbox", toastConfig);
            let updatedMessageData = state?.MessagesSuccess?.results?.map(message =>
                (message.id === action.payload.id ? null : message)).filter(Boolean);
            return {
                ...state,
                inboxSuccess: action.payload,
                MessageDetails: null,
                MessagesSuccess: {
                    ...state.MessagesSuccess,
                    results: updatedMessageData,
                },
            };
        case moveToInboxFail:
            return {
                ...state,
                inboxFail: action.payload.message,
            };
        case getDeleteSuccess:
            toast.success("Successfully moved to trash", toastConfig);
            let updatedMessages = state.MessagesSuccess?.results?.map(message =>
                (message.id === action.payload.id ? null : message)).filter(Boolean);
            return {
                ...state,
                deleteSuccess: action.payload,
                MessageDetails: null,
                MessagesSuccess: {
                    ...state.MessagesSuccess,
                    results: updatedMessages,
                },
            };
        case getDeleteFail:
            return {
                ...state,
                deleteFail: action.payload.message,
            };
        case updateMessageNoteSuccess:
            return {
                ...state,
                MessageDetails: action.payload,
            };
        case updateMessageNoteFail:
            return {
                ...state,
                MessageDetailsFail: action.payload.message,
            };

        case resetData:
            return {
                ...state,
                MessageDetails: {},
            };
        default:
            return state;
    }
}
